import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { CUSTOM_COHORT_JOB } from '../models/cohortJob'

import { appHttp } from '@/shared/http'

const FEATURE_OWNED_ERRORS: AxiosRequestConfig = {
  suppressGlobalErrorHandler: true,
  meta: { suppressGlobalErrorHandler: true },
}

/**
 * Custom Cohort raw-data job — contract 27 §6.1 #5 (v3 `CustomCohortCreate.vue:69`).
 *
 * The 13-field adjust-job spec is the module constant `CUSTOM_COHORT_JOB`, not component code.
 * The only user input in the whole body is `parameters.event_slug_names`; BE-27-04 asks for
 * `POST /workspaces/{ws}/cohorts/custom { event_slug_names }` so this body can collapse to it.
 */
export class CohortConfigApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async createCustomCohort(workspaceId: number, eventSlugNames: string[]): Promise<void> {
    await this.http.post(
      `/custom-raw-data/create/${workspaceId}`,
      {
        ...CUSTOM_COHORT_JOB,
        parameters: { ...CUSTOM_COHORT_JOB.parameters, event_slug_names: [...eventSlugNames] },
      },
      FEATURE_OWNED_ERRORS,
    )
  }
}
